import { render } from "./ModalDifference.vue?vue&type=template&id=05284e06&scoped=true"
import script from "./ModalDifference.vue?vue&type=script&lang=js"
export * from "./ModalDifference.vue?vue&type=script&lang=js"

import "./ModalDifference.vue?vue&type=style&index=0&id=05284e06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05284e06"]])

export default __exports__